/*
  <H4
    color={color} 
    size={size} 
    className={className}
  />
  - - - - - - - - - - - - -
  color -> white / black
  size -> xl / lg / md / sm / xs
  className -> css classes
  - - - - - - - - - - - - -
*/

export default function H4({
  color,
  className,
  desktopSize,
  mobileSize,
  children,
  ...props
}) {
  return (
    <h4
      className={`title tc-${color} title--${desktopSize}-d title--${mobileSize} ${className}`}
      {...props}
    >
      {children}
    </h4>
  );
}

H4.defaultProps = {
  color: "black",
  desktopSize: "xs",
  mobileSize: "xxs",
  className: "",
};
